import { createContext, useContext } from 'react';

const AtomicScreenContext = createContext<string | undefined>(undefined);

export const AtomicScreenProvider = AtomicScreenContext.Provider;

export const useAtomicScreen = () => useContext(AtomicScreenContext);
